import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

import { getImagesByQuery } from './js/pixabay-api';

import {
  createGallery,
  clearGallery,
  showLoader,
  hideLoader,
  showLoadMoreButton,
  hideLoadMoreButton,
} from './js/render-functions';

const form = document.querySelector('.form');
form.addEventListener('submit', handleSubmit);
const loadMore = document.querySelector('.btn-more');
loadMore.addEventListener('click', onLoadMore);

let page = 1;
let query = '';

async function handleSubmit(event) {
  event.preventDefault();
  const valueSearch = event.target.elements['search-text'].value
    .toLowerCase()
    .trim();
  if (!valueSearch) {
    iziToast.show({
      message: 'Please enter a search query',
      color: 'red',
      position: 'bottomRight',
      overlayColor: 'rgba(0, 0, 0, 0.6)',
    });
    return;
  }
  query = valueSearch;
  page = 1;
  clearGallery();
  hideLoadMoreButton();
  showLoader();

  try {
    const data = await getImagesByQuery(query, page);

    if (data.hits.length === 0) {
      iziToast.show({
        message:
          'Sorry, there are no images matching your search query. Please try again!',
        color: 'blue',
        position: 'topCenter',
      });
      return;
    }
    createGallery(data.hits);
    const totalPages = Math.ceil(data.totalHits / 15);
    if (page < totalPages) {
      showLoadMoreButton();
    } else {
      hideLoadMoreButton();

      iziToast.show({
        message: "We're sorry, but you've reached the end of search results.",
        position: 'topRight',
      });
    }
  } catch (error) {
    iziToast.show({
      message: 'Error! Try again later',
      color: 'red',
    });
  } finally {
    hideLoader();
    event.target.reset();
  }
}
async function onLoadMore() {
  page++;

  hideLoadMoreButton();
  showLoader();
  try {
    const data = await getImagesByQuery(query, page);
    createGallery(data.hits);
    const totalPages = Math.ceil(data.totalHits / 15);
    if (page >= totalPages) {
      hideLoadMoreButton();

      iziToast.show({
        message: "We're sorry, but you've reached the end of search results.",
      });
    } else {
      showLoadMoreButton();
    }
    const card = document.querySelector('.gallery-item');
    const cardHeight = card.getBoundingClientRect().height;
    window.scrollBy({
      left: 0,
      top: cardHeight * 2,
      behavior: 'smooth',
    });
  } catch (error) {
    iziToast.show({
      message: 'Error! Try again later',
      color: 'red',
    });
  } finally {
    hideLoader();
  }
}
